(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function isTeaserNode(node) {
    if (!node || !node.classList) return false;
    return Array.from(node.classList).some(function (className) {
      return className.indexOf('kl-teaser-') === 0;
    });
  }

  // Klaviyo re-renders its teaser when we change its styles. If we re-pin on
  // every DOM mutation, we trigger another Klaviyo re-render, which fires our
  // observer again -> infinite feedback loop that pegs the CPU. Pin each node
  // exactly once and never touch it again.
  var pinned = new WeakSet();

  function pinTeaser(teaser) {
    if (pinned.has(teaser)) return;
    pinned.add(teaser);

    teaser.style.setProperty('left', '12px', 'important');
    teaser.style.setProperty('right', 'auto', 'important');
    teaser.style.setProperty('transform', 'none', 'important');
    teaser.style.setProperty('margin-left', '0', 'important');
    teaser.style.setProperty('margin-right', '0', 'important');
    teaser.style.setProperty('width', 'auto', 'important');
    teaser.style.setProperty('max-width', '120px', 'important');
    teaser.style.setProperty('padding', '6px 12px', 'important');
    teaser.style.setProperty('font-size', '11px', 'important');
    teaser.style.setProperty('white-space', 'nowrap', 'important');
    teaser.style.setProperty('overflow', 'visible', 'important');
    teaser.style.setProperty(
      'bottom',
      'calc(var(--ciw-mobile-action-clearance, 0px) + 16px + env(safe-area-inset-bottom, 0px))',
      'important'
    );

    var pointer = teaser.querySelector('[class*="Teaser-pointer"]');
    if (!pointer) return;

    pointer.style.setProperty('border-radius', '999px', 'important');
    pointer.style.setProperty('max-width', '120px', 'important');
    pointer.style.setProperty('padding', '6px 12px', 'important');
    pointer.style.setProperty('min-height', 'unset', 'important');
    pointer.style.setProperty('font-size', '11px', 'important');
    pointer.style.setProperty('white-space', 'nowrap', 'important');
  }

  var observer = null;
  var scanQueued = false;

  function applyPins() {
    scanQueued = false;
    if (!isMobile()) return;

    // pinTeaser writes inline styles. If the observer is still watching while
    // we do that, our own style writes retrigger this callback and spin into
    // an infinite loop. Disconnect first, then reconnect after.
    if (observer) observer.disconnect();

    document.querySelectorAll('[class*="kl-teaser-"]').forEach(function (node) {
      if (!isTeaserNode(node)) return;
      pinTeaser(node);
    });

    if (observer) startObserving();
  }

  function scan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(applyPins);
  }

  function startObserving() {
    // Only watch for the teaser being added/removed. We deliberately do NOT
    // watch style/class attributes: pinTeaser changes styles, and observing
    // those changes is what caused the feedback loop.
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function start() {
    observer = new MutationObserver(scan);
    scan();
    startObserving();

    MOBILE_MQ.addEventListener('change', function (event) {
      if (event.matches) scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
